import { Heading, CloseButton, Button, Modal, List, ListItem } from '@smarterservices/smarter-ui';
import useSessionStore from '../../stores/session';
import useAppStore from '../../stores/app';

const AssistCheckinReminder = (props) => {
  const { sessionSid } = props;

  // Get the session to check reviewBy field
  const session = useSessionStore((state) => state.sessions?.[sessionSid]);
  const proctors = useAppStore((state) => state.proctors);

  // Get the reviewing proctor's name
  const reviewBy = session?.sessionData?.reviewBy;
  const reviewingProctor = reviewBy ? proctors?.[reviewBy] : null;
  const proctorName = reviewingProctor
    ? `${reviewingProctor?.firstName} ${reviewingProctor?.lastName?.charAt(0)?.toUpperCase()}.`
    : 'another proctor';

  const proctorFirstName = reviewingProctor
    ? `${reviewingProctor?.firstName}`
    : 'they';

  return (
    <Modal
      open={props.show}
      label="Assist Check-in"
      shouldCloseOnDocumentClick
      mountNode={() => document.getElementById('FocusModeContainer')}
      insertAt="top"
      constrain="parent"
    >
      <Modal.Header>
        <CloseButton
          placement="end"
          offset="small"
          onClick={() => props.onCancel()}
          screenReaderLabel="Close"
        />
        <Heading>Check-in Assistance Reminder</Heading>
      </Modal.Header>
      <Modal.Body>
        You are about to assist <strong>{proctorName}</strong> with checking in this session. Here are some important points to keep in mind when assisting:

        <List margin="medium">
          <ListItem>If {proctorFirstName} disconnects from this session, you will be disconnected as well.</ListItem>
          <ListItem margin="x-small 0 0 0">You <strong>will not</strong> have the Check-in tab available to you, this is only available to the proctor checking the session in.</ListItem>
        </List>



      </Modal.Body>
      <Modal.Footer>
        <Button color="primary" type="submit" onClick={() => props.onConfirmation()}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssistCheckinReminder;
